import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import SendIcon from '@mui/icons-material/Send';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Swal from 'sweetalert2';
import { API_URL, API_CLOUD } from '../../Constants';
import TextField from '@mui/material/TextField';

const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    color: 'white',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const PrettoSlider = styled(Slider)({
    color: '#A8C8AF',
    height: 8,
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 12,
        background: 'unset',
        padding: 0,
        width: 40,
        height: 40,
        borderRadius: '50% 50% 50% 0',
        backgroundColor: '#52af77',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&:before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        }
    },
});


let apiUrl = API_URL;
let apiCloud = API_CLOUD;


export default function QuotaSimulator() {
    const [clientName, setClientName] = useState('');
    const [monthlyCapability, setMonthlyCapability] = useState(0);
    const [creditValue, setCreditValue] = useState(3500000);
    const [quotasQuantity, setQuotasQuantity] = React.useState(18);
    const [quotaValue, setQuotaValue] = React.useState(0);
    const [minQuotas, setMinQuotas] = React.useState(2);
    const [interestRate, setInterestRate] = React.useState(1.93);


    useEffect(() => {
        if (localStorage.getItem('clientUuid') == null) {
            window.location = '/inprocess-credits';
        }

        fetch(apiUrl + '/v1/parameters/', {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    setInterestRate(res.interestRate);
                })
            } else {
                alert("Parameters Not Found");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });


        fetch(apiCloud + '/v1/clients/' + localStorage.getItem('clientUuid'), {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setClientName(res.name + ' ' + res.lastName);
                })
            } else {
                alert("Viability Not Found for clientUuid" + localStorage.getItem('clientUuid'));
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });

        fetch(apiCloud + '/v1/viability-studies/client/' + localStorage.getItem('clientUuid'), {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setMonthlyCapability(res.monthlyCapability)
                })
            } else {
                alert("Viability Not Found for clientUuid: " + localStorage.getItem('clientUuid'));
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });
        calculateQuotaValue(3500000);

    }, [])


    function calculateQuotaValue(valueToChange) {
        let valorReal = creditValue;
        if (valueToChange != undefined) { valorReal = valueToChange }
        console.log("en calculo: credit = " + valorReal);
        setQuotaValue((-1) * PMT(interestRate / 100, quotasQuantity, valorReal, 0, 0));
    }

    function PMT(ir, np, pv, fv, type) {
        /*
         * ir   - interest rate per month
         * np   - number of periods (months)
         * pv   - present value
         * fv   - future value
         * type - when the payments are due:
         *        0: end of the period, e.g. end of month (default)
         *        1: beginning of period
         */
        var pmt, pvif;

        fv || (fv = 0);
        type || (type = 0);

        if (ir === 0)
            return -(pv + fv) / np;

        pvif = Math.pow(1 + ir, np);
        pmt = - ir * (pv * pvif + fv) / (pvif - 1);

        if (type === 1)
            pmt /= (1 + ir);

        return pmt;
    }

    const handleQuotaSelected = () => {
        Swal.fire({
            title: '¿Desea crear este crédito? ',
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor: '#161e55',
            cancelButtonColor: '#387A9C',
            confirmButtonText: 'Crear',
            denyButtonText: `Don't save`
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                if (quotaValue <= monthlyCapability) {
                    Swal.fire('Solicitud de crédito exitosa!', '', 'success')
                    createCredit();
                    updateFeasibility();
                    sleep(1500).then(() => {
                        window.location = '/download-pagare';
                    })
                } else {
                    Swal.fire('Cupo muy alto', '', 'warning')
                }
            }
        });
        console.log(monthlyCapability)
    }

    const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }


    function updateFeasibility() {
        let feasibility = { status: "LOAD_DOCUMENTS" }
        fetch(apiCloud + '/v1/feasibility-inquiries/' + localStorage.getItem("feasibilityUuid"), {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json ',
                'Accept': 'application/json',
            },
            body: JSON.stringify(feasibility),
        }).then(function (response) {
            if (response.ok) {
                response.json().then(function (res) {
                    console.log(res.uuid)
                });
            }
        }).catch(function (error) {
            console.log('Hubo un problema con la petición Fetch:' + error.message);
        });
    }

    const handleBackToInProcessCredits = () => {
        window.location = '/inprocess-credits';
    }

    var formatter = new Intl.NumberFormat('es-US', {
        style: 'currency',
        currency: 'COP',
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });


    function createCredit() {
        let creditRequest = {
            totalValue: creditValue,
            quotaValue: quotaValue,
            clientUuid: localStorage.getItem('clientUuid'),
            commerceUuid: localStorage.getItem('commerceUuid'),
            quotasNumber: quotasQuantity,
            interestRate: interestRate
        }
        fetch(apiUrl + '/v1/credits', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json ',
                'Accept': 'application/json',
            },
            body: JSON.stringify(creditRequest),
        }).then(function (response) {
            if (response.ok) {
                response.json().then(function (res) {
                    console.log(res);
                    localStorage.setItem("pagareUuid", res.pagareUuid);
                });
            }
        }).catch(function (error) {
            console.log('Hubo un problema con la petición Fetch:' + error.message);
        });
    }

    const creditMarks = [{ value: 500000, label: "500.000", }, { value: 3500000, label: "3'500.000", }, { value: 6000000, label: "6'000.000" }];

    const quotasMarks = [
        { value: 2, label: "2" }, { value: 4, label: "4" }, { value: 6, label: "6" }, { value: 8, label: "8" }, { value: 10, label: "10" }, { value: 12, label: "12" },
        { value: 14, label: "14" }, { value: 16, label: "16" }, { value: 18, label: "18" }
    ];

    const handleChangeTextValue = () => {
        let newTextValue = document.getElementById("text-credit-value").value;
        console.log("holaa: " + newTextValue);
        if (newTextValue == '' || newTextValue < 500000) { newTextValue = 500000 };
        if (newTextValue > 6000000) { newTextValue = 6000000 };
        setCreditValue(Number(newTextValue));
        calculateQuotaValue(Number(newTextValue));
    };

    const handleSliderChange = (event, newValue) => {
        if (typeof newValue === 'number') {
            setCreditValue(newValue);
        }
        calculateQuotaValue();
    };

    const handleChangeQuotasQuantity = (event, newValue) => {
        if (typeof newValue === 'number') {
            setQuotasQuantity(newValue);
        }
        calculateQuotaValue();
    };



    return (
        <React.Fragment>
            <Header />
            <Container maxWidth="md">
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs />
                        <Grid item xs={8} >
                            <br />
                            <h1>Calcula las cuotas para </h1>
                            <h1>{clientName}</h1>
                            <br />
                            <Box sx={{ width: 320 }}>
                                <Box sx={{ m: 3 }} />
                                Valor de credito: {formatter.format(creditValue)}
                                <br />
                                <br />
                                <br />

                                <TextField id="text-credit-value" label='' variant="standard" type="number" style={{ paddingRight: 30 }} />

                                <ButtonPrincipal onClick={handleChangeTextValue}>Calcular</ButtonPrincipal>

                                <br />
                                <br />
                                <br />
                                <PrettoSlider
                                    value={creditValue}
                                    valueLabelDisplay="off"
                                    aria-labelledby="pretto slider"
                                    defaultValue={3500000}
                                    marks={creditMarks}
                                    step={100000}
                                    min={500000}
                                    max={6000000}
                                    onChange={handleSliderChange}
                                />
                            </Box>
                            <br />
                            <br />
                            <Box sx={{ width: 320 }}>
                                <Box sx={{ m: 3 }} />
                                <Typography gutterBottom>Número de Cuotas </Typography>
                                <br />
                                <br />
                                <PrettoSlider
                                    id='creditValue'
                                    valueLabelDisplay="on"
                                    aria-label="pretto slider"
                                    defaultValue={18}
                                    marks={quotasMarks}
                                    min={minQuotas}
                                    max={18}
                                    onChange={handleChangeQuotasQuantity}
                                />
                            </Box>
                            <br />
                            <h2>{quotasQuantity} cuotas de: {formatter.format(quotaValue)}</h2>
                            <br />
                            <Stack direction="row" spacing={2}>
                                <ButtonPrincipal variant="contained" onClick={handleBackToInProcessCredits}>Volver</ButtonPrincipal>
                                <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={handleQuotaSelected} className='button'>
                                    Seleccionar Cuota
                                </ButtonPrincipal>
                            </Stack>
                        </Grid>
                        <Grid item xs />
                    </Grid>
                </Box>
            </Container>
        </React.Fragment>
    );
}